import React, { Component } from 'react'
// import Tabs from '../tabs/tabs';
import '../../utils/stylesheets/layout/layout.css'
import Toolbar from '../../components/toolbar/toolbar';
import { connect } from 'react-redux';
import Tabs from '../tabs/mld_tabs'
import constants from '../../utils/constants/apiconstant';
import { withStyles } from '@material-ui/core/styles';
import { scrollToTopPage } from '../../utils/commonfunction';
const styles = (theme) => ({
  root: {
    display: "grid",
    gridTemplateColumns: "10% 80% 10%",
    marginTop: "5%",
    // [theme.breakpoints.down("920")]: {
    //   marginTop: "30%",
    // },
    // [theme.breakpoints.down("600")]: {
    //    marginTop: "55%",
    // }
  }
})
class MLD_Layout extends Component {

  componentDidMount() {
    scrollToTopPage()
  }

  render() {
    const { classes } = this.props
    return (
      <div >
        <Toolbar title={constants.Common.MLD} productID={10} childFunc={this.props.childFunc} data={this.props.mfHeader2}></Toolbar>
        {/* <div className="reportDesign"> */}
        <div className={classes.root}>
          <div ></div>
          <div>
            <Tabs page={this.props.location} />
          </div>
          <div></div>
        </div>
        {/* </div> */}

      </div>
    )
  }
}
const mapStateToProps = state => ({
  date: state.Login.date,
  mfHeader2: state.Card.MLD,
  sessionID: state.Login.sessionID,
  clientID: state.Login.logindetails.ClientID,
  userID: state.Login.userID,
  date: state.Login.date,
  logindetails: state.Login.logindetails
})
export default withStyles(styles)(connect(mapStateToProps, null)(MLD_Layout))